import React, {useEffect, useState} from "react";
import {Route, Routes} from "react-router-dom";

import MainPage from "./main/MainPage";
import {AccountProvider} from "./hooks/AccountContext";
import {SaveHandlerProvider} from "./hooks/SaveHandlerContext"; // ← hinzufügen

const App: React.FC = () => {
    const [theme, setTheme] = useState<string>(() => {
        const stored: string | null = localStorage.getItem("theme");
        return stored ?? "system";
    });

    useEffect(() => {
        const applyTheme = (value: string): void => {
            if (value === "system") {
                const prefersDark: boolean = window.matchMedia("(prefers-color-scheme: dark)").matches;
                document.documentElement.setAttribute("data-theme", prefersDark ? "dark" : "light");
            } else {
                document.documentElement.setAttribute("data-theme", value);
            }
        };

        applyTheme(theme);

        const mediaQuery: MediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = (e: MediaQueryListEvent): void => {
            if (theme === "system") {
                document.documentElement.setAttribute("data-theme", e.matches ? "dark" : "light");
            }
        };

        mediaQuery.addEventListener("change", listener);
        return () => mediaQuery.removeEventListener("change", listener);
    }, [theme]);

    const updateTheme = (value: string): void => {
        setTheme(value);
        localStorage.setItem("theme", value);
    };

    return (
        <AccountProvider>
            <SaveHandlerProvider>   {/* ← HIER eingefügt */}
                <Routes>
                    <Route
                        path="/*"
                        element={
                            <MainPage
                                theme={theme}
                                setTheme={updateTheme}
                            />
                        }
                    />
                </Routes>
            </SaveHandlerProvider>
        </AccountProvider>
    );
};

export default App;